import { X } from 'lucide-react'
import type React from 'react'
import { cn } from '@/lib/utils'
import type { MobileNavigationProps } from '@/types/components'

export const MobileNavigation: React.FC<MobileNavigationProps> = ({
  isOpen,
  currentPath,
  onClose,
}) => {
  const navigation = [
    { name: 'Glossary', href: '/glossary' },
    { name: 'Black Book', href: '/blackbook' },
  ]

  if (!isOpen) return null

  return (
    <div className="md:hidden border-t">
      {/* Close button */}
      <div className="flex justify-end p-2">
        <button
          type="button"
          onClick={onClose}
          className="p-2 rounded-md text-gray-700 hover:bg-gray-100"
        >
          <X className="h-6 w-6" />
        </button>
      </div>

      <div className="px-2 pt-2 pb-3 space-y-1">
        {navigation.map((item) => {
          const isActive = currentPath === item.href
          return (
            <a
              key={item.name}
              href={item.href}
              className={cn(
                'block px-3 py-2 rounded-md text-base font-medium',
                isActive
                  ? 'bg-primary/10 text-primary'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-primary',
              )}
            >
              {item.name}
            </a>
          )
        })}
      </div>
    </div>
  )
}
